<template lang="html">
<div class="max-w-screen-xl w-full mx-auto pb-32">
	<div class="flex space-x-16">
		<!-- Settings category selector tree like -->
		<div class="w-1/5 py-10 bg-gray-50 dark:bg-gray-800 px-2 border-r dark:border-gray-700 border-gray-200">
			<button class="w-full text-left hover:bg-gray-200 dark:hover:bg-gray-700 py-2 px-2 border border-gray-200 dark:border-gray-600 rounded-md dark:text-gray-100 text-gray-800 text-lg"
			:class="activeTab == 'communication' ? 'dark:bg-gray-700 bg-gray-200' : ''"
			@click="activeTab = 'communication'">
				Communication devices
			</button>	
			<button class="w-full text-left hover:bg-gray-200 dark:hover:bg-gray-700 py-2 px-2 border border-gray-200 dark:border-gray-600 rounded-md dark:text-gray-100  text-gray-800 text-lg"
			:class="activeTab == 'connection' ? 'dark:bg-gray-700 bg-gray-200' : ''"
			@click="activeTab = 'connection'">
				Connection</button>	
			<button class="w-full text-left hover:bg-gray-200 dark:hover:bg-gray-700 py-2 px-2 border border-gray-200 dark:border-gray-600 rounded-md dark:text-gray-100  text-gray-800 text-lg"
			:class="activeTab == 'theme' ? 'dark:bg-gray-700 bg-gray-200' : ''"
			@click="activeTab = 'theme'">
				Display</button>	
			<button class="w-full text-left hover:bg-gray-200 dark:hover:bg-gray-700 py-2 px-2 border border-gray-200 dark:border-gray-600 rounded-md dark:text-gray-100  text-gray-800 text-lg"
			:class="activeTab == 'manage' ? 'dark:bg-gray-700 bg-gray-200' : ''"
			@click="showManageParticipantsSettings()">
				Manage participants</button>	

			<button class="w-full text-left hover:bg-gray-200 dark:hover:bg-gray-700 py-2 px-2 border border-gray-200 dark:border-gray-600 rounded-md dark:text-gray-100  text-gray-800 text-lg"
			:class="activeTab == 'hooks' ? 'dark:bg-gray-700 bg-gray-200' : ''"
			@click="activeTab = 'hooks'" v-if="hooksEnabled">
				Hooks</button>	
			<button class="w-full text-left hover:bg-gray-200 dark:hover:bg-gray-700 py-2 px-2 border border-gray-200 dark:border-gray-600 rounded-md dark:text-red-100  text-red-800 text-lg"
			:class="activeTab == 'experimental' ? 'dark:bg-red-700 bg-red-200' : 'dark:bg-red-800 bg-red-100'"
			@click="activeTab = 'experimental'" v-if="allowDemoMode">
				Experimental</button>	
			<button class="w-full text-left hover:bg-gray-200 dark:hover:bg-gray-700 py-2 px-2 border border-gray-200 dark:border-gray-600 rounded-md dark:text-red-100  text-red-800 text-lg btn-disabled"
			:class="activeTab == 'general' ? 'dark:bg-gray-700 bg-gray-200' : 'dark:bg-gray-800 bg-gray-100'" disabled 
			@click="activeTab = 'general'">
				Timeout</button>	

		</div>
		<div class="w-4/5 py-10" style="min-height: 80vh">
			<div v-show="activeTab == 'manage'">
				<manage-participants :is-modal="false"
                           :room="room" :roles="['Guest', 'Production']"
                           :is-in-trial="false" ref="manageParticipantsSettings"></manage-participants>
				</div>
			<div v-show="activeTab == 'communication'">
				<div class="flex space-x-12 mt-4">
					<div class="w-1/2">
						<div class="font-medium text-lg">Host</div>
						<div class="text-gray-500 dark:text-gray-400">
							Set up the peripherals you will use to communicate with
							everyone. If you enable the Open mic switch, you won't
							need to press the Hold-to-Talk button.
						</div>
					</div>
					<div class="w-1/2">
						<div class="flex flex-wrap justify-between">
							<div class="text-base font-semibold">
								Host microphone
							</div>
							<div class="flex flex-wrap space-x-2 items-center">
								<div>
									Open mic
								</div>
								<div class="form-switch muteMicrophone" data-id="microphone">
									<input type="checkbox" checked>
									<i></i>
								</div>
							</div>
						</div>
						<select class="audioSource form-input w-full" data-id="0"></select>
						<div class="rounded-md mt-2" >
							<sound-meter id="soundMeterMain" :horizontal="true"></sound-meter>
						</div>
						<div class="flex flex-wrap mt-4">
							<div class="text-base font-semibold">
								Host headphones
							</div>
						</div>
						<div class="flex flex-wrap items-baseline justify-between">
							<select class="audioOutput form-input flex-1 mr-2" data-id="0"></select>
							<button class="btn w-20" @click="testHeadphones()" :class="playingTestAudio ? 'btn-disabled' : 'btn-secondary'" :disabled="playingTestAudio">
								Test
							</button>
							<audio src="/audio/test_audio.mp3" id="headphoneTestAudio"></audio>
						</div>
					</div>
				</div>
				<div class="flex space-x-12 mt-4">
					<div class="w-1/2">
						<div class="font-medium text-lg">Video settings</div>
						<div class="text-gray-500 dark:text-gray-400">
							Change your live feed's video and audio source. <br />
							Please be aware that the new selection may take a few
								extra seconds to display.
						</div>
					</div>
					<div class="w-1/2">
						<div class="text-base font-semibold">
							Video source
						</div>
						<div class="rounded-md overflow-hidden my-2 relative">
							<video id="localVideoSetting" autoplay playsinline muted class="bg-black w-full"></video>
							<div class="bg-black opacity-75 text-white flex space-y-2 flex-col absolute z-10 inset-0 items-center justify-center" style="display:none" id="localVideoSettingChangingCamera">
								<!-- Spinning semi-circle -->
								<svg class="animate-spin  h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
									<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
									<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
								</svg>
								<h1>
									Changing camera source
								</h1>
								</div>	
						</div>
						<select class="videoSource form-input w-full" data-id="0"></select>
						<div class="text-base font-semibold mt-4">
							Video's audio source
						</div>
						<select class="audioSource form-input w-full" data-id="1"></select>
						<div class="rounded-md mt-2">
							<sound-meter id="soundMeterCamera" :horizontal="true"></sound-meter>
						</div>
					</div>
				</div>
				<div class="flex space-x-12 mt-4">
					<div class="w-1/2">
						<div class="font-medium text-lg">On-set speakers</div>
						<div class="text-gray-500 dark:text-gray-400">
							Enable your production team to speak directly with the 
							actors or crew on set by setting up a speaker.
						</div>
					</div>
					<div class="w-1/2">
						<div class="flex flex-wrap mt-2">
							<div class="text-base font-semibold">
								On-set speakers
							</div>
						</div>
						<div class="flex flex-wrap items-baseline justify-between">
							<select class="audioOutput form-input flex-1 mr-2" data-id="3"></select>
							<button class="btn w-20" @click="testDirectorToSet()"  :class="playingTestAudio ? 'btn-disabled' : 'btn-secondary'"  :disabled="playingTestAudio">
								Test
							</button>
							<!-- Audio to test Director To Set connection -->
							<audio id='director_to_set_TEST_AUDIO' data-role='production' src="/audio/test_audio.mp3"></audio>
						</div>
					</div>
				</div>
			</div>	
			<div v-show="activeTab == 'connection'">
				<connection-quality></connection-quality>
				<hr class="mt-6 mb-4 dark:border-gray-700" />
				<div class="flex flex-wrap justify-between items-center">
					<div class="text-lg font-medium">
						Server connection status
					</div>
					<div class="text-xs uppercase font-bold tracking-wider">
						<div class="bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-500 px-4 py-2 rounded-md" v-if="connectionStatus">
							{{connectionStatus.signalingState}} - {{connectionStatus.iceGatheringState}} - {{ connectionStatus.iceConnectionState }}
						</div>
					</div>
				</div>
				<div class="flex flex-col space-y-4 mt-4">
					<div class="flex flex-wrap justify-between items-center">
						<div class="text-lg font-medium">
							Connection status
					</div>
					<button v-on:click="showConnectionStats = !showConnectionStats" class="btn btn-secondary">
						{{ showConnectionStats ? "Hide stats" : "Show stats" }}
					</button>
				</div>
				<div class="text-xs uppercase font-bold tracking-wider" v-show="showConnectionStats">
					<div class="" v-if="connectionStatus">
						<table class="w-full divide-y divide-gray-200 dark:divide-gray-700">
							<tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
								<tr>
									<th class="px-6 py-3 bg-gray-50 dark:bg-gray-700 text-left text-xs leading-4 font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
										Signaling State
									</th>
									<td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900 dark:text-gray-100 uppercase">
										{{connectionStatus.signalingState}}
									</td>
								</tr>
								<tr>
									<th class="px-6 py-3 bg-gray-50 dark:bg-gray-700 text-left text-xs leading-4 font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
										ICE Gathering State:
									</th>
									<td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900 dark:text-gray-100 uppercase">
										{{connectionStatus.iceGatheringState}}
									</td>
								</tr>
								<tr>
									<th class="px-6 py-3 bg-gray-50 dark:bg-gray-700 text-left text-xs leading-4 font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
										Bytes Exchanged
									</th>
									<td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900 dark:text-gray-100 uppercase">
										Recieved: {{connectionStatus.bytesReceived}}
										<hr class="dark:border-gray-700" />
										Sent: {{connectionStatus.bytesSent}}
										<div class="hidden">
											<hr class="dark:border-gray-700" />
											Local: {{connectionStatus.localAddress }}
											<hr class="dark:border-gray-700" />
											Remote: {{connectionStatus.remoteAddress}}
										</div>
									</td>
								</tr>
								<tr v-if="connectionStatus.audio">
									<th class="px-6 py-3 bg-gray-50 dark:bg-gray-700 text-left text-xs leading-4 font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
										Audio
									</th>
									<td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900 dark:text-gray-100 uppercase">
										Inbound: {{connectionStatus.audio.inbound}}
										<span v-html="trackStatsJSONToHTML(connectionStatus.audio.inbound)"></span>
										<hr class="dark:border-gray-700" />
										Outbound:
										<hr class="dark:border-gray-700" />
										<span v-html="trackStatsJSONToHTML(connectionStatus.audio.outbound)"></span>
										<hr class="dark:border-gray-700" />
									</td>
								</tr>
								<tr v-if="connectionStatus.video">
									<th class="px-6 py-3 bg-gray-50 dark:bg-gray-700 text-left text-xs leading-4 font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
										Video
									</th>
									<td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900 dark:text-gray-100 uppercase">
										Inbound:
										<span v-html="trackStatsJSONToHTML(connectionStatus.video.inbound)"></span>
										<hr class="dark:border-gray-700" />
										Outbound:
										<span v-html="trackStatsJSONToHTML(connectionStatus.video.outbound)"></span>
									</td>
								</tr>
								<tr>
									<th class="px-6 py-3 bg-gray-50 dark:bg-gray-700 text-left text-xs leading-4 font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
										Memory
									</th>
									<td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900 dark:text-gray-100 uppercase">
										{{ memoryInfo() }}
										<hr class="dark:border-gray-700" />
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<hr class="mt-6 mb-4 dark:border-gray-700" />
			<div class="flex flex-wrap justify-between items-center">
				<div class="text-lg font-medium">
					Low data mode
				</div>
				<div class="text-xs uppercase bold text-gray-600 tracking-wider">
					<div class="">
						<div class="form-switch red-switch ml-2" @click="onLowDataModeToggle">
							<input type="checkbox" v-model="lowDataModeOn">
							<i></i>
						</div>
					</div>
				</div>
			</div>
			<div class="text-gray-500 dark:text-gray-400 mt-1 w-128">
				This feature will help you when you have low bandwith conditions.
				It will improve your connectivity by reducing your streaming and recording quality.
				It will also lower the bandwith needed to upload your recordings.
			</div>

			</div>	
			<div v-show="activeTab == 'theme'">
				<div class="flex flex-wrap justify-between items-center"  v-if="darkModeEnabled">
					<div class="text-lg font-medium">
						Dark mode
					</div>
					<div class="text-xs uppercase bold text-gray-600 tracking-wider">
						<div class="flex space-x-2">
							<!-- Sun icon -->
							<svg class="h-4 w-4 fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M12 2C12.5523 2 13 2.44772 13 3V4C13 4.55228 12.5523 5 12 5C11.4477 5 11 4.55228 11 4V3C11 2.44772 11.4477 2 12 2ZM19.0711 4.92893C19.4616 5.31945 19.4616 5.95261 19.0711 6.34314L18.364 7.05025C17.9735 7.44077 17.3403 7.44077 16.9498 7.05025C16.5593 6.65972 16.5593 6.02656 16.9498 5.63603L17.6569 4.92893C18.0474 4.5384 18.6806 4.5384 19.0711 4.92893ZM4.92893 4.92893C5.31945 4.5384 5.95262 4.5384 6.34314 4.92893L7.05025 5.63603C7.44077 6.02656 7.44077 6.65972 7.05025 7.05025C6.65972 7.44077 6.02656 7.44077 5.63603 7.05025L4.92893 6.34314C4.5384 5.95262 4.5384 5.31945 4.92893 4.92893ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8ZM6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12ZM2 12C2 11.4477 2.44772 11 3 11H4C4.55228 11 5 11.4477 5 12C5 12.5523 4.55228 13 4 13H3C2.44772 13 2 12.5523 2 12ZM19 12C19 11.4477 19.4477 11 20 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H20C19.4477 13 19 12.5523 19 12ZM5.63603 16.9497C6.02656 16.5592 6.65972 16.5592 7.05025 16.9497C7.44077 17.3403 7.44077 17.9734 7.05025 18.364L6.34314 19.0711C5.95262 19.4616 5.31945 19.4616 4.92893 19.0711C4.5384 18.6805 4.5384 18.0474 4.92893 17.6568L5.63603 16.9497ZM16.9498 18.364C16.5593 17.9734 16.5593 17.3403 16.9498 16.9497C17.3403 16.5592 17.9735 16.5592 18.364 16.9497L19.0711 17.6568C19.4616 18.0474 19.4616 18.6805 19.0711 19.0711C18.6806 19.4616 18.0474 19.4616 17.6569 19.0711L16.9498 18.364ZM12 19C12.5523 19 13 19.4477 13 20V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V20C11 19.4477 11.4477 19 12 19Z" clip-rule="evenodd"/></svg>
							<div class="form-switch ml-2" @click="onDarkModeToggle">
								<input type="checkbox" v-model="darkModeOn">
								<i></i>
							</div>
							<!-- Moon icon -->
							<svg class="h-4 w-4 fill-current" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path d="M17.2929 13.2929C16.2886 13.7471 15.1738 13.9999 14 13.9999C9.58172 13.9999 6 10.4182 6 5.9999C6 4.82593 6.25287 3.71102 6.70712 2.70667C3.93137 3.96191 2 6.75526 2 9.9997C2 14.418 5.58172 17.9997 10 17.9997C13.2443 17.9997 16.0376 16.0685 17.2929 13.2929Z"/></svg>
						</div>
					</div>
				</div>
				<div class="text-gray-500 dark:text-gray-400 mt-1 w-128" v-if="darkModeEnabled">
				This will darken the interface to reduce the amount of light emitted from your screen.
				This feature can help reduce eyestrain for longer sessions and at night.
				</div>
				<hr class="mt-6 mb-4 dark:border-gray-700" />
				<div class="flex flex-wrap justify-between items-center">
				<div class="text-lg font-medium">
					Participant information overlay
				</div>
				<div class="text-xs uppercase bold text-gray-600 tracking-wider">
					<div class="">
						<div class="form-switch ml-2" @click="onParticipantInfoToggle">
							<input type="checkbox" v-model="showParticipantInfo">
							<i></i>
						</div>
					</div>
				</div>
				</div>
				<div class="text-gray-500 dark:text-gray-400 mt-1">
					Toggle whether the participant name, email and IP will be shown on the viewport. 
				</div>
			</div>
			<div v-show="activeTab == 'hooks'" v-if="hooksEnabled">
				<div class="text-3xl font-medium">
					Hooks
				</div>
				<div class="grid grid-cols-4 gap-4 mt-4">
					<!-- Hooks  -->
					<div class="bg-gray-200 px-4 py-4 rounded-md">
						<div class="font-medium text-lg">Autoconnect users</div>
						<div class="text-gray-500 dark:text-gray-400">
							Connect users as soon as they get connected
						</div>
						<div class="form-switch ml-2" @click="onChangeHook__autoconnect">
							<input type="checkbox" v-model="hookAutoConnect" />
							<i></i>
						</div>
					</div>

					<div class="bg-gray-200 px-4 py-4 rounded-md">
						<div class="font-medium text-lg">Open chat on message</div>
						<div class="text-gray-500 dark:text-gray-400">
							Open chat window when a new message arrives.
						</div>
						<div class="form-switch ml-2" @click="onChangeHook__openChat">
							<input type="checkbox" v-model="hookOpenChat" />
							<i></i>
						</div>
					</div>

					<div class="bg-gray-200 px-4 py-4 rounded-md">
						<div class="font-medium text-lg">Autoplay take when ready</div>
						<div class="text-gray-500 dark:text-gray-400">
							Autoplay the take as soon as every participant is ready
						</div>
						<div class="form-switch ml-2" @click="onChangeHook__autoplayWhenReady">
							<input type="checkbox" v-model="hookAutoplayWhenReady" />
							<i></i>
						</div>
					</div>
				</div>
			</div>	
			<div v-show="activeTab == 'experimental'">
				<div class="flex flex-wrap justify-between items-center">
					<div class="text-lg font-medium">
						Demo mode
					</div>
					<div class="text-xs uppercase bold text-gray-600 tracking-wider">
						<div class="">
							<div class="form-switch red-switch ml-2" @click="onDemoModeToggle">
								<input type="checkbox" v-model="demoModeOn">
								<i></i>
							</div>
						</div>
					</div>
				</div>
				<div class="text-gray-500 dark:text-gray-400 mt-1">
					This feature is only meant to be used by the MicTap Team.
					This will disable the takes playback on the guests' side.
				</div>
				<hr class="my-4 dark:border-gray-700" />
				<div class="flex flex-wrap justify-between items-center">
					<div class="text-lg font-medium">
						Video bitrate
					</div>
					<div class="text-gray-500 dark:text-gray-400 mt-1">
						This feature is only meant to be used by the MicTap Team. Use it together with the scaling factor.
					</div>
					<div class="text-xs uppercase bold text-gray-600 tracking-wider w-full mt-5">
						<div class="flex items-baseline">
							<input type="number" placeholder="0" v-model="selectedBitrate" class="form-input">
							<div class="flex-shrink-0 px-4">
								in kbps
							</div>
						</div>
						<div class="flex items-baseline">
							<div class="w-full">
								<input class="w-full" type="range" v-model="selectedBitrate" min="200" max="9000" @change="onChangeBitrate" step="25">
							</div>
							<div class="flex-shrink-0 px-4">
								in kbps
							</div>
						</div>
					</div>
				</div>
				<div class="mt-8 flex flex-wrap justify-between items-center">
					<div class="text-lg font-medium">
						Video scaling factor
					</div>
					<div class="text-gray-500 dark:text-gray-400 mt-1">
						This feature is only meant to be used by the MicTap Team. Use it together with the bitrate to tweak it.
						A scaling factor of 1 means no scaling.
						A scaling factor of 2 means that the resolution will be halved.
					</div>
					<div class="text-xs uppercase bold text-gray-600 tracking-wider w-full mt-5">
						<div class="flex items-baseline">
							<input type="number" placeholder="0" v-model="scalingFactor" class="form-input">
							<div class="flex-shrink-0 px-4">
								in kbps
							</div>
						</div>
						<div class="flex items-baseline">
							<div class="w-full">
								<input class="w-full" type="range" v-model="scalingFactor" min="1" max="10" @change="onChangeBitrate" step="0.1">
							</div>
							<div class="flex-shrink-0 px-4">
								in kbps
							</div>
						</div>
					</div>
				</div>
				<hr class="my-4 dark:border-gray-700" />
				<div class="flex flex-wrap justify-between items-center">
					<div class="text-lg font-medium">
						Audio bitrate
					</div>
					<div class="text-gray-500 dark:text-gray-400 mt-1">
						This feature is only meant to be used by the MicTap Team. 
					</div>
					<div class="text-xs uppercase bold text-gray-600 tracking-wider w-full mt-5">
						<div class="flex items-baseline">
							<input type="number" placeholder="0" v-model="selectedAudioBitrate" class="form-input">
							<div class="flex-shrink-0 px-4">
								in kbps
							</div>
						</div>
						<div class="flex items-baseline">
							<div class="w-full">
								<input class="w-full" type="range" v-model="selectedAudioBitrate" min="6000" max="320000" @change="onChangeAudioBitrate" step="100">
							</div>
							<div class="flex-shrink-0 px-4">
								in kbps
							</div>
						</div>
					</div>
				</div>

					<button class="btn btn-secondary mt-4 hidden" @click="onSwitchCamera">Switch cam</button>
				<!--div class="flex flex-wrap justify-between items-center">
					<div class="text-lg font-medium">
						Framesize
					</div>
					<div class="text-xs uppercase bold text-gray-600 tracking-wider">
						<select v-model="selectedResolution" class="form-input" @change="onChangeSelectedResolution">
							<option value="360p">360p</option>
							<option value="480p">480p</option>
							<option value="720p">720p</option>
							<option value="1080p">1080p</option>
							<option value="4K">4K</option>
						</select>
					</div>
				</div-->
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { detectBrowser } from 'utils/browser';
import commandsManager from 'general/CommandsManager';
import hooksManager from 'general/HooksManager';
import { changeVideoResolution, updateConstraints } from 'webrtc/mediaDevices'

export default {
  props: {
    room: {
      type: Object,
      required: true,
      validator: function (value) {
        return value.name // check if it has an id
      }
    },
	hooksEnabled: {
	  type: Boolean,
	  required: false,
	  default: false
	},
	darkModeEnabled: {
	  type: Boolean,
	  required: false,
	  default: false
	}
  },
  data() {
	return {
	  selectedResolution: '720p',

	  selectedAudioBitrate: 32 * 100,
	  selectedBitrate: 5000,
	  scalingFactor: 1.0,

	  lowDataModeOn: false,
	  demoModeOn: false,
	  allowDemoMode: false,
	  showDemoHalo: false,
	  inputBeforeDemoMode: null,
	  darkModeOn: false,

	  connectionStatus: 'Not connected',
	  playingTestAudio: false,
	  showConnectionStats: false,

	  changingCamera: false,
	  showParticipantInfo: false,

	  switchAuxCamera: false,

	  // hooks
	  //
	  hookAutoConnect: false,
	  hookOpenChat: false,
	  hookAutoplayWhenReady: false,

	  // navigation
	  activeTab: 'communication'
	}
  },
	mounted() {
		// register to demo mode toggle
		$('body').on('keydown', (ev) => {
			// if its writing anything disable this listener
			if ($('input').is(':focus')) return;
			if ($('textarea').is(':focus')) return;

			// dont use alt because it turns the key into another language basically.
			// Ctrl + Shift + M is pressed to enable demo mode
			if (ev.ctrlKey && ev.shiftKey && ev.key === 'M') {
				this.allowDemoMode = true;
			}
		});
		hooksManager.enabled = this.hooksEnabled;

		// get from local storage preference of dark mode
		let darkMode = localStorage.getItem('mt_mirror_host_dark_mode')
		// if the preference is not set then set it to true
		if (darkMode == "true" || darkMode == null) {
			this.onDarkModeToggle();
		}
	},
  methods: {
	trackStatsJSONToHTML(track){
	  if (track.bitrateMean == undefined) return ""
	  let html = `
				Bitrate mean: ${track.bitrateMean || 'N/A'}
				</br>
				Framerate mean: ${track.framerateMean || 'N/A'}
				</br>
				NackCount: ${track.nackCount || 'N/A'}
				</br>
				PacketsSent: ${track.packetsSent || 'N/A'}
				</br>
				PacketsLost: ${track.packetsLost || 'N/A'}
				</br>
			<hr />
			`
	  if (track.frameWidth){
		html += `
				${track.frameWidth} x ${track.frameHeight } @ ${track.framesPerSecond}fps
				</br>
				`
	  }

	  if (track.codec == null || track.codec == undefined) return html

	  html += `Codec:
				${track.codec.mimeType }  @ ${track.codec.cockRate || 'N/A' }
				</br>
				${track.codec.paloadType || 'N/A' }  -  SDP FMT ${track.codec.sdpFmtpLine || 'N/A' }
			`
	  return html
	},
	testHeadphones(){
	  // put sounds thru headphones
	  const soundID = "#headphoneTestAudio"
	  if ($(soundID).length){
		this.playingTestAudio = true;
		$(soundID)[0].play()
		$(soundID)[0].onended = () => {
		  this.playingTestAudio = false;
		}
	  }
	},
	testDirectorToSet(){
	  // put sounds thru director to set audio
	  const soundID = "#director_to_set_TEST_AUDIO"
	  if ($(soundID).length){
		this.playingTestAudio = true;
		$(soundID)[0].play()
		$(soundID)[0].onended = () => {
		  this.playingTestAudio = false;
		}
	  }
	},
	// onChangeSelectedResolution(){
	// 	this.selectedBitrate = 2610;
	// 	changeVideoResolution(this.selectedResolution);
	// },
	onChangeAudioBitrate(){
	  if (manager && manager.rtc){
		manager.rtc.SetBitrateForAudio(Math.max(this.selectedAudioBitrate, 6000)); // minimum bitrate is 6000
	  }
	},
	onChangeBitrate(){
	  if (manager && manager.rtc){
		manager.rtc.SetBitrateForVideo(this.selectedBitrate, this.scalingFactor);
	  }
	},
	onSwitchCamera(){
	  this.switchCameraAux = !this.switchCameraAux
	  commandsManager.sendAllCommand('mirror--toggle_aux_camera', {enabled: this.switchCameraAux})
	  this.$emit('switchAuxCamera', this.switchCameraAux);
	},
	onDemoModeToggle(){
	  this.demoModeOn = !this.demoModeOn;
	  commandsManager.sendAllCommand('set_demo_mode', {demoModeOn: this.demoModeOn})
	  this.$emit('demoModeOn', this.demoModeOn);

	  if(this.demoModeOn === true){
		// ask for screen share
		const option = document.createElement('option');
		option.value = 'SCREEN';
		option.text = "Share my screen"
		// $('select.videoSource');
		// $(".videoSource[data-id='0']").each( function () {
		$('.videoSource').append($(option).clone());
		// });
		// save the input to restore it later
		this.inputBeforeDemoMode = $(".videoSource[data-id='0']").val();
		$(".videoSource[data-id='0']").val('SCREEN')
		updateConstraints();


		let haloHTML = `<div class="fixed h-32 w-32 border-8 border-green-500 rounded-full pointer-events-none" id="halo-cursor" style="z-index: 30"></div>`

		$("body").append(haloHTML)
		$("#halo-cursor").removeClass("hidden");
		$("#halo-cursor").css("transition", "width 0.1s ease-in-out, height 0.1s ease-in-out, margin-left 0.1s ease-in-out, margin-top 0.1s ease-in-out");
		$(document).on("mousedown keydown", (e) => {
		  if (e.key && e.key !== 'h') { return }
		  $("#halo-cursor").css("width", "2rem");
		  $("#halo-cursor").css("margin-left", "3rem");
		  $("#halo-cursor").css("margin-top", "3rem");
		  $("#halo-cursor").css("height", "2rem");
		});
		$(document).on("mouseup keyup", (e) => {
		  if (e.key && e.key !== 'h') { return }
		  $("#halo-cursor").css("margin-left", "0rem");
		  $("#halo-cursor").css("margin-top", "0rem");
		  $("#halo-cursor").css("width", "8rem");
		  $("#halo-cursor").css("height", "8rem");
		});
		$(document).on("mousemove", (e) => {
		  $("#halo-cursor").css("top", (e.clientY - 16 * 4) + "px");
		  $("#halo-cursor").css("left", (e.clientX - 16 * 4) + "px");
		})
	  }
	  else if (this.demoModeOn === false){
		$(".videoSource option[value='SCREEN']").remove();
		$(".videoSource[data-id='0']").val(this.inputBeforeDemoMode);
		updateConstraints();
		$("#halo-cursor").addClass("hidden");
		$("#halo-cursor").remove();
	  }
	},
	onLowDataModeToggle(){
	  this.lowDataModeOn = !this.lowDataModeOn;

	  if (window.manager && window.manager.disableLowDataMode){
		if (this.lowDataModeOn) window.manager.enableLowDataMode()
		if (!this.lowDataModeOn) window.manager.disableLowDataMode()
	  }

	  commandsManager.sendAllCommand('set_low_data_mode', {lowDataModeOn: this.lowDataModeOn})
	  this.$emit('lowDataModeOn', this.lowDataModeOn);
	},
	onDarkModeToggle(){
	  this.darkModeOn = !this.darkModeOn;
	  if(this.darkModeOn) document.querySelector('html').classList.add('dark');
	  else document.querySelector('html').classList.remove('dark');
	  // update local storage with dark mode preference
	  localStorage.setItem('mt_mirror_host_dark_mode', this.darkModeOn ? 'true' : 'false');
	},
	onParticipantInfoToggle(){
	  this.showParticipantInfo = !this.showParticipantInfo;
	  if (window.manager && window.manager.toggleParticipantInfo) {
		window.manager.toggleParticipantInfo(this.showParticipantInfo)
	  }
	},
    showManageParticipantsSettings(){
		this.activeTab = "manage";
      	if (this.$refs.manageParticipantsSettings) {
        	this.$refs.manageParticipantsSettings.loadParticipants();
		}
    },
	onAppear(){
		if (this.activeTab == "manage") {
			this.showManageParticipantsSettings();
		}
	},
	memoryInfo(){
	  const memory = window.performance.memory;
	  return `${parseInt(memory.usedJSHeapSize / 1024 / 1024) }mb / ${parseInt(memory.jsHeapSizeLimit / 1024 / 1024)}mb`
	},
	onChangeHook__autoconnect(){
	  if(this.hooksEnabled == false) return;
	  this.hookAutoConnect = !this.hookAutoConnect;
	  hooksManager.toggleHooksById("participants--connect-peer", this.hookAutoConnect);
	},
	onChangeHook__openChat(){
	  if(this.hooksEnabled == false) return;
	  this.hookOpenChat = !this.hookOpenChat;
	  hooksManager.toggleHooksById("chat--open-chat", this.hookOpenChat);
	},
	onChangeHook__autoplayWhenReady(){
	  if(this.hooksEnabled == false) return;
	  this.hookAutoplayWhenReady = !this.hookAutoplayWhenReady;
	  hooksManager.toggleHooksById("video-take-list--autoplay-when-ready", this.hookAutoplayWhenReady);
	},

  },
}
</script>
<style lang="">

</style>
